	// // Sematext
	// declare global {
	// 	interface Window { strum: Function; }
	// }

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { AppRoutingModule } from './app-routing.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ContextMenuModule } from 'ngx-contextmenu';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { AngularDraggableModule } from 'angular2-draggable';
import { JwtModule, JWT_OPTIONS, JwtInterceptor } from '@auth0/angular-jwt';

import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatDialogModule, MatProgressBarModule, MatSliderModule } from '@angular/material';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { CookieModule } from 'ngx-cookie';
import { AngularSplitModule } from 'angular-split';

import { LoginComponent } from './components/auth/login/login.component';

import { AppComponent } from './app.component';
import { AzgivComponent } from './components/azgiv/azgiv.component';
import { TestComponent } from './components/test/test.component';

import { ContentJobsComponent } from './components/content-jobs/content-jobs.component';
// import { ContentUserAdminComponent } from './components/content-user-admin/content-user-admin.component';
import { ContentConfigComponent } from './components/content-config/content-config.component';
import { JobsAddFilesComponent } from './components/content-jobs/jobs-add-files/jobs-add-files.component';
import { JobsFieldMappingComponent } from './components/content-jobs/jobs-field-mapping/jobs-field-mapping.component';
import { JobsSummaryComponent } from './components/content-jobs/jobs-summary/jobs-summary.component';
import { JobsUploadLogsComponent } from './components/content-jobs/jobs-upload-logs/jobs-upload-logs.component';

import { IdleModalComponent } from './components/modal/idle-modal/idle-modal.component';
import { ConfirmModalComponent } from './components/modal/confirm-modal/confirm-modal.component';
import { LoadingSpinnerComponent } from './feature-components/loading-spinner/loading-spinner.component';
import { LayerSelectModalComponent } from './components/content-jobs/layer-select-modal/layer-select-modal.component';
import { PaneHeaderComponent } from './components/pane-header/pane-header.component';
import { CommonDatagridComponent } from './components/common-datagrid/common-datagrid.component';
import { CommonTablePagingComponent } from './components/common-datagrid/common-table-paging/common-table-paging.component';
import { CommonMapComponent } from './components/common-map/common-map.component';
import { CommonSocketMsgComponent } from './components/common-socket-msg/common-socket-msg.component';
import { PopupMessageComponent } from './feature-components/popup-message/popup-message.component';

import { AppinfoService } from './services/appinfo.service';
import { CancelTranscService } from './services/cancel-transc.service';
import { ColumnFilterService } from './services/column-filter.service';
import { CommonFunctionService } from './services/common-function.service';
import { CommonMapService } from './services/common-map.service';
import { CommonModalService } from './services/common-modal.service';
import { CommonRequestService } from './services/common-request.service';
import { CommonTableService } from './services/common-table.service';
import { CommonUtilityService } from './services/common-utility.service';
import { AdminService } from './services/admin.service';
import { AdminGuardService } from './services/admin-guard.service';
import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthTokenService } from './services/auth-token.service';
import { UserService } from './services/user.service';
import { AzgivService } from './services/azgiv.service';
import { ArcmapConnectService } from './services/arcmap-connect.service';
import { BrowserDetectService } from './services/browser-detect.service';
import { ContentJobsService } from './components/content-jobs/content-jobs.service';
import { DownloadService } from './services/download.service';
import { FieldMappingService } from './services/field-mapping.service';
import { GfoService } from './services/gfo.service';
import { IdleService } from './services/idle.service';
import { LayerService } from './services/layer.service';
import { LayerQcService } from './services/layer-qc.service';
import { MiscService } from './services/misc.service';
import { PaneControlService } from './services/pane-control.service';
import { RequestTableService } from './services/request-table.service';
import { ResolverLayersService } from './services/resolver-layers.service';
import { ResolverJobsTransactionsService } from './services/resolver-jobs-transactions.service';
import { SocketService } from './services/socket.service';
import { TransactionsService } from './services/transactions.service';
// import { PopupMessageService } from './feature-components/popup-message/popup-message.service';
import { EnablePublishLayerService } from './services/enable-publish-layer.service';

import { FileDropZoneDirective } from './directives/file-drop-zone.directive';
import { TableDataPipe } from './pipes/table-data.pipe';
import { CommonSocketLogsComponent } from './components/common-socket-logs/common-socket-logs.component';
import { JobsQcLogsComponent } from './components/content-jobs/jobs-qc-logs/jobs-qc-logs.component';
import { DashboardMainComponent } from './components/content-dashboard/dashboard-main.component';
import { CommonColumnFilterComponent } from './components/common-column-filter/common-column-filter.component';
import { UserAdminDataComponent } from './components/content-user-admin/user-admin-data/user-admin-data.component';
import { LoginAzComponent } from './components/auth/login-az/login-az.component';
import { ContentUserGuideComponent } from './components/content-user-guide/content-user-guide.component';
import { LayerPreviewModalComponent } from './components/content-jobs/jobs-field-mapping/layer-preview-modal/layer-preview-modal.component';
import { JobsBuildtopoLogsComponent } from './components/content-jobs/jobs-buildtopo-logs/jobs-buildtopo-logs.component';
import { FeatureAvailableAgenciesComponent } from './components/feature-available-agencies/feature-available-agencies.component';
import { ConfigUsersComponent } from './components/content-config/config-users/config-users.component';
import { ConfigSubAgenciesComponent } from './components/content-config/config-sub-agencies/config-sub-agencies.component';
import { EditSubAgencyModalComponent } from './components/content-config/config-sub-agencies/edit-sub-agency-modal/edit-sub-agency-modal.component';
import { AddSubAgencyModalComponent } from './components/content-config/config-sub-agencies/add-sub-agency-modal/add-sub-agency-modal.component';
import { ValidateEqualDirective } from './directives/validators/validate-equal.directive';
import { AddUserModalComponent } from './components/content-config/config-users/add-user-modal/add-user-modal.component';
import { UserVerifyComponent } from './components/auth/user-verify/user-verify.component';
import { ModalCheckMappingComponent } from './components/content-jobs/modal-check-mapping/modal-check-mapping.component';
import { IntegratorService } from './services/integrator.service';
import { IntegratorSelectComponent } from './components/modal/integrator-select/integrator-select.component';
import { ResolverSelectedCustomerService } from './services/resolver-selected-customer.service';
import { ConfigIntegratorsComponent } from './components/content-config/config-integrators/config-integrators.component';
import { GuardConfigIntegratorService } from './services/guard-config-integrator.service';
import { SocketSidekickService } from './services/socket-sidekick.service';
import { SidekickService } from './services/sidekick.service';
import { HttpConfigInterceptor } from './interceptor/httpconfig.interceptor';
import { SocketErrorsModalComponent } from './components/modal/socket-errors-modal/socket-errors-modal.component';
import { EditBatchComponent } from './components/content-edit/edit-batch/edit-batch.component';
import { ConfigNagComponent } from './components/content-config/config-nag/config-nag.component';
import { NagAliasModalComponent } from './components/content-config/config-nag/nag-alias-modal/nag-alias-modal.component';
import { NagStandardModalComponent } from './components/content-config/config-nag/nag-standard-modal/nag-standard-modal.component';
import { EditCardComponent } from './components/content-edit/edit-card/edit-card.component';
import { ContentLayersComponent } from './components/content-layers/content-layers.component';
import { LayerComplexComponent } from './components/content-layers/layer-complex/layer-complex.component';
import { FeatureVerticalTabsComponent } from './components/feature-vertical-tabs/feature-vertical-tabs.component';
import { QcFiltersInterlayersComponent } from './components/content-layers/qc-filters-interlayers/qc-filters-interlayers.component';
import { QcFiltersMyLayersComponent } from './components/content-layers/qc-filters-my-layers/qc-filters-my-layers.component';
import { ModalAdditionalErrorComponent } from './components/content-layers/modal-additional-error/modal-additional-error.component';
import { AdditionalErrorMyLayersComponent } from './components/content-layers/additional-error-my-layers/additional-error-my-layers.component';
import { QcExceptionsComponent } from './components/content-layers/qc-exceptions/qc-exceptions.component';
import { AddExceptionModalComponent } from './components/content-layers/add-exception-modal/add-exception-modal.component';
import { ValidateRangeDirective } from './directives/validators/validate-range.directive';
import { EditCardFishboneComponent } from './components/content-edit/edit-card-fishbone/edit-card-fishbone.component';
import { EditTopoErrorComponent } from './components/content-edit/edit-topo-error/edit-topo-error.component';
import { FeatureCoordinatesDisplayComponent } from './components/feature-coordinates-display/feature-coordinates-display.component';
import { FeatureGeojsonUnitComponent } from './components/feature-geojson-unit/feature-geojson-unit.component';
import { EditTopoErrorInterComponent } from './components/content-edit/edit-topo-error-inter/edit-topo-error-inter.component';
import { FeatParentLayerComponent } from './components/feat-parent-layer/feat-parent-layer.component';
import { MainDataMapComponent } from './components/content-layers/main-data-map/main-data-map.component';
import { FeatAttributeFiltersPopupComponent } from './components/feat-attribute-filters-popup/feat-attribute-filters-popup.component';
import { FeatAttributeFilterLabelsComponent } from './components/feat-attribute-filter-labels/feat-attribute-filter-labels.component';
import { FeatSplashScreenComponent } from './components/feat-splash-screen/feat-splash-screen.component';
import { TooltipHelpComponent } from './components/popout-modals/tooltip-help/tooltip-help.component';
import { FeatLayerControlComponent } from './components/feat-layer-control/feat-layer-control.component';
import { LayerControlItemComponent } from './components/feat-layer-control/layer-control-item/layer-control-item.component';
import { HtmlTooltipDirective } from './directives/html-tooltip.directive';
import { FeatPanelToggleComponent } from './components/feat-panel-toggle/feat-panel-toggle.component';
import { FeatMapFilterComponent } from './components/feat-map-filter/feat-map-filter.component';
// import { FeatLayerSelectionComponent } from './components/feat-layer-selection/feat-layer-selection.component';
import { FeatDownloadLayersComponent } from './components/feat-download-layers/feat-download-layers.component';
import { ModalDownloadLayersComponent } from './components/feat-download-layers/modal-download-layers/modal-download-layers.component';
import { FeatAddressSearchComponent } from './components/feat-address-search/feat-address-search.component';
import { FeatD3StatisticsComponent } from './components/feat-d3-statistics/feat-d3-statistics.component';
import { FeatLayerTabsComponent } from './components/feat-layer-tabs/feat-layer-tabs.component';
import { FeatMapControlsComponent } from './components/feat-map-controls/feat-map-controls.component';
import { FeatArchiveModeComponent } from './components/feat-archive-mode/feat-archive-mode.component';
import { TestLayerSelectComponent } from './components/modal/test-layer-select/test-layer-select.component';
import { FeatFilterLabelsQacodeComponent } from './components/feat-filter-labels-qacode/feat-filter-labels-qacode.component';
import { FeatFilterLabelsMapComponent } from './components/feat-filter-labels-map/feat-filter-labels-map.component';
import { FeatTransactionLogComponent } from './components/feat-transaction-log/feat-transaction-log.component';
import { FeatResolutionCenterComponent } from './components/feat-resolution-center/feat-resolution-center.component';
import { ResolutionAOEComponent } from './components/feat-resolution-center/resolution-aoe/resolution-aoe.component';
import { ResolutionASQComponent } from './components/feat-resolution-center/resolution-asq/resolution-asq.component';
import { ResolutionDAVComponent } from './components/feat-resolution-center/resolution-dav/resolution-dav.component';
import { ResolutionInspectorComponent } from './components/feat-resolution-center/resolution-inspector/resolution-inspector.component';
import { ViewLogComponent } from './components/feat-transaction-log/view-log/view-log.component';
import { ResolutionRAOComponent } from './components/feat-resolution-center/resolution-rao/resolution-rao.component';
import { ResolutionCADComponent } from './components/feat-resolution-center/resolution-cad/resolution-cad.component';
import { RcQaCodesComponent } from './components/feat-resolution-center/rc-qa-codes/rc-qa-codes.component';
import { ButtonSwitchComponent } from './components/feat-resolution-center/button-switch/button-switch.component';
import { ButtonExceptComponent } from './components/feat-resolution-center/button-except/button-except.component';
import { RcCellComponent } from './components/feat-resolution-center/rc-cell/rc-cell.component';
import { DomainResolutionInspectorComponent } from './components/feat-resolution-center/domain-resolution-inspector/domain-resolution-inspector.component';
import { FeatA3iComponent } from './components/feat-a3i/feat-a3i.component';
import { A3iTabComponent } from './components/feat-a3i/a3i-tab/a3i-tab.component';
import { A3iEditCardComponent } from './components/feat-a3i/a3i-edit-card/a3i-edit-card.component';
import { ContentReportsComponent } from './components/content-reports/content-reports.component';
import { TabReportFiltersComponent } from './components/content-reports/tab-report-filters/tab-report-filters.component';
import { InterlayerReportTabsComponent } from './components/content-reports/interlayer-report-tabs/interlayer-report-tabs.component';
import { CommonTemplateRefsComponent } from './components/common-template-refs/common-template-refs.component';
import { ButtonFlipRoadComponent } from './components/feat-resolution-center/button-flip-road/button-flip-road.component';
import { LayerStateIconComponent } from './components/feat-layer-tabs/layer-state-icon/layer-state-icon.component';
import { InterlayerCardComponent } from './components/content-reports/interlayer-card/interlayer-card.component';
import { InterlayerSubjectCardsComponent } from './components/content-reports/interlayer-subject-cards/interlayer-subject-cards.component';
import { InterlayerRefCardsComponent } from './components/content-reports/interlayer-ref-cards/interlayer-ref-cards.component';
import { UnsavedChangesWarningComponent } from './components/modal/unsaved-changes-warning/unsaved-changes-warning.component';
import { FeatFlipRoadComponent } from './components/feat-flip-road/feat-flip-road.component';
import { RcRoadDirectionComponent } from './components/feat-resolution-center/rc-road-direction/rc-road-direction.component';
import { LineSplitComponent } from './components/feat-edit/line-split/line-split.component';
import { LineWithMeasureComponent } from './components/feat-edit/line-with-measure/line-with-measure.component';
import { FeatEditCellComponent } from './components/feat-edit-cell/feat-edit-cell.component';
import { ToolLineSplitComponent } from './components/feat-edit/tool-line-split/tool-line-split.component';
import { ToolLineMergeComponent } from './components/feat-edit/tool-line-merge/tool-line-merge.component';
import { LineMergeComponent } from './components/feat-edit/line-merge/line-merge.component';
import { ConfigAgencyProfileComponent } from './components/content-config/config-agency-profile/config-agency-profile.component';
import { FeatMapPickFeatureComponent } from './components/feat-map-pick-feature/feat-map-pick-feature.component';
import { InputUppercaseDirective } from './directives/input-uppercase.directive';
import { CopyLinePropertiesComponent } from './components/feat-edit-address/copy-line-properties/copy-line-properties.component';
import { AddressManageComponent } from './components/feat-edit/address-manage/address-manage.component';
import { AddressManageHintComponent } from './components/feat-edit/address-manage/address-manage-hint/address-manage-hint.component';
import { AddressManageToolComponent } from './components/feat-edit/address-manage/address-manage-tool/address-manage-tool.component';
import { StackedAddressesPickComponent } from './components/feat-edit/address-manage/stacked-addresses-pick/stacked-addresses-pick.component';
import { FeatConfigNguidComponent } from './components/feat-config-nguid/feat-config-nguid.component';
import { EditWizardComponent } from './components/feat-edit/edit-wizard/edit-wizard.component';
import { EditWizardIconComponent } from './components/feat-edit/edit-wizard/edit-wizard-icon/edit-wizard-icon.component';
import { WizardAddressRelocationComponent } from './components/feat-edit/edit-wizard/wizard-address-relocation/wizard-address-relocation.component';
import { WizardCenterlineComponent } from './components/feat-edit/edit-wizard/wizard-centerline/wizard-centerline.component';
import { WizardStepTitleComponent } from './components/feat-edit/edit-wizard/wizard-step-title/wizard-step-title.component';
import { NagPlacenameResoComponent } from './components/content-config/config-nag/nag-placename-reso/nag-placename-reso.component';
import { QcLayerSelectModalComponent } from './components/modal/qc-layer-select-modal/qc-layer-select-modal.component';
import { FeatMapToolsComponent } from './components/feat-map-tools/feat-map-tools.component';
import { A3iWizardComponent } from './components/feat-a3i/a3i-wizard/a3i-wizard.component';
import { A3iWizardIconComponent } from './components/feat-a3i/a3i-wizard/a3i-wizard-icon/a3i-wizard-icon.component';
import { FeatMapBookmarkManagerComponent } from './components/feat-map-bookmark-manager/feat-map-bookmark-manager.component';
import { MapLegendComponent } from './components/feat-map-tools/map-legend/map-legend.component';
import { FeatReferenceDocumentComponent } from './components/feat-reference-document/feat-reference-document.component';
import { FeatReferenceDocumentTabComponent } from './components/feat-reference-document-tab/feat-reference-document-tab.component';
import { LineGeomEditWizardComponent } from './components/feat-edit/line-geom-edit-wizard/line-geom-edit-wizard.component';
import { LineGeomEditWizardIconComponent } from './components/feat-edit/line-geom-edit-wizard/line-geom-edit-wizard-icon/line-geom-edit-wizard-icon.component';
import { BoundaryGeomEditWizardComponent } from './components/feat-edit/boundary-geom-edit-wizard/boundary-geom-edit-wizard.component';
import { BoundaryGeomEditIconComponent } from './components/feat-edit/boundary-geom-edit-wizard/boundary-geom-edit-icon/boundary-geom-edit-icon.component';

// export function authHttpServiceFactory(http: Http, options: RequestOptions, tokenService: AuthTokenService) {
// 	return new AuthHttp(new AuthConfig({
// 		tokenName: tokenService.authTokenName,
// 		noTokenScheme: true
// 	}), http, options);
// }
export function jwtOptionsFactory(tokenService: AuthTokenService) {
	return {
		tokenGetter: () => {
			return tokenService.getToken();
		},
		authScheme: '',
		whitelistedDomains: [
			'localhost:4202', 'localhost:3000', 'localhost:3001',
			'192.168.88.172:3000', '192.168.88.172:3001', '192.168.88.129:3001', '192.168.88.129:3000',
			'192.168.88.32:4203',
			'66.85.138.75:4200',
			'api.linearbench.com', 'linearbench.com'
		]
	};
}
export function initFunc(userService: UserService, browserDetectService: BrowserDetectService, socketSidekickService: SocketSidekickService) {
	return () => {
		// Detect Browser
		const browser = browserDetectService.getBrowserInfo();
		browserDetectService.warning(browser);
		// Check socket sidekick param
		socketSidekickService.checkSocketParam();
		// Init User Info
		userService.appInit();
	};
}

@NgModule({
	declarations: [
		AppComponent,
		AzgivComponent,
		TestComponent,
		LoadingSpinnerComponent,
		PaneHeaderComponent,
		LoginComponent,
		ContentJobsComponent,
		// ContentUserAdminComponent,
		ContentConfigComponent,
		JobsAddFilesComponent,
		JobsFieldMappingComponent,
		JobsSummaryComponent,
		LayerSelectModalComponent,
		FileDropZoneDirective,
		IdleModalComponent,
		JobsUploadLogsComponent,
		CommonDatagridComponent,
		TableDataPipe,
		CommonTablePagingComponent,
		CommonMapComponent,
		PopupMessageComponent,
		CommonSocketMsgComponent,
		ConfirmModalComponent,
		CommonSocketLogsComponent,
		JobsQcLogsComponent,
		DashboardMainComponent,
		CommonColumnFilterComponent,
		UserAdminDataComponent,
		LoginAzComponent,
		ContentUserGuideComponent,
		LayerPreviewModalComponent,
		JobsBuildtopoLogsComponent,
		FeatureAvailableAgenciesComponent,
		ConfigUsersComponent,
		ConfigSubAgenciesComponent,
		EditSubAgencyModalComponent,
		AddSubAgencyModalComponent,
		ValidateEqualDirective,
		AddUserModalComponent,
		UserVerifyComponent,
		ModalCheckMappingComponent,
		IntegratorSelectComponent,
		ConfigIntegratorsComponent,
		SocketErrorsModalComponent,
		EditBatchComponent,
		ConfigNagComponent,
		NagAliasModalComponent,
		NagStandardModalComponent,
		EditCardComponent,
		ContentLayersComponent,
		LayerComplexComponent,
		FeatureVerticalTabsComponent,
		QcFiltersInterlayersComponent,
		QcFiltersMyLayersComponent,
		ModalAdditionalErrorComponent,
		AdditionalErrorMyLayersComponent,
		QcExceptionsComponent,
		AddExceptionModalComponent,
		ValidateRangeDirective,
		EditCardFishboneComponent,
		EditTopoErrorComponent,
		FeatureCoordinatesDisplayComponent,
		FeatureGeojsonUnitComponent,
		EditTopoErrorInterComponent,
		FeatParentLayerComponent,
		MainDataMapComponent,
		FeatAttributeFiltersPopupComponent,
		FeatAttributeFilterLabelsComponent,
		FeatSplashScreenComponent,
		TooltipHelpComponent,
		FeatLayerControlComponent,
		LayerControlItemComponent,
		HtmlTooltipDirective,
		FeatPanelToggleComponent,
		FeatMapFilterComponent,
		// FeatLayerSelectionComponent,
		FeatDownloadLayersComponent,
		ModalDownloadLayersComponent,
		FeatAddressSearchComponent,
		FeatD3StatisticsComponent,
		FeatLayerTabsComponent,
		FeatMapControlsComponent,
		FeatArchiveModeComponent,
		TestLayerSelectComponent,
		FeatFilterLabelsQacodeComponent,
		FeatFilterLabelsMapComponent,
		FeatTransactionLogComponent,
		FeatResolutionCenterComponent,
		ResolutionAOEComponent,
		ResolutionASQComponent,
		ResolutionDAVComponent,
		ResolutionInspectorComponent,
		ViewLogComponent,
		ResolutionRAOComponent,
		ResolutionCADComponent,
		RcQaCodesComponent,
		ButtonSwitchComponent,
		ButtonExceptComponent,
		RcCellComponent,
		DomainResolutionInspectorComponent,
		FeatA3iComponent,
		A3iTabComponent,
		A3iEditCardComponent,
		ContentReportsComponent,
		TabReportFiltersComponent,
		InterlayerReportTabsComponent,
		CommonTemplateRefsComponent,
		ButtonFlipRoadComponent,
		LayerStateIconComponent,
		InterlayerCardComponent,
		InterlayerSubjectCardsComponent,
		InterlayerRefCardsComponent,
		UnsavedChangesWarningComponent,
		FeatFlipRoadComponent,
		RcRoadDirectionComponent,
		LineSplitComponent,
		LineWithMeasureComponent,
		FeatEditCellComponent,
		ToolLineSplitComponent,
		ToolLineMergeComponent,
		LineMergeComponent,
		ConfigAgencyProfileComponent,
		FeatMapPickFeatureComponent,
		InputUppercaseDirective,
		CopyLinePropertiesComponent,
		AddressManageComponent,
		AddressManageHintComponent,
		AddressManageToolComponent,
		StackedAddressesPickComponent,
		FeatConfigNguidComponent,
		EditWizardComponent,
		EditWizardIconComponent,
		WizardAddressRelocationComponent,
		WizardCenterlineComponent,
		WizardStepTitleComponent,
		NagPlacenameResoComponent,
		QcLayerSelectModalComponent,
		FeatMapToolsComponent,
		A3iWizardComponent,
		A3iWizardIconComponent,
		FeatMapBookmarkManagerComponent,
		MapLegendComponent,
		FeatReferenceDocumentComponent,
		FeatReferenceDocumentTabComponent,
		LineGeomEditWizardComponent,
		LineGeomEditWizardIconComponent,
		BoundaryGeomEditWizardComponent,
		BoundaryGeomEditIconComponent,
	],
	entryComponents: [
		A3iWizardComponent,
		AddExceptionModalComponent,
		AddSubAgencyModalComponent,
		AddUserModalComponent,
		AddressManageComponent,
		BoundaryGeomEditWizardComponent,
		ConfirmModalComponent,
		EditSubAgencyModalComponent,
		LayerSelectModalComponent,
		IdleModalComponent,
		IntegratorSelectComponent,
		PopupMessageComponent,
		LayerPreviewModalComponent,
		NagAliasModalComponent,
		NagStandardModalComponent,
		ModalCheckMappingComponent,
		ModalAdditionalErrorComponent,
		NagPlacenameResoComponent,
		SocketErrorsModalComponent,
		TooltipHelpComponent,
		FeatLayerControlComponent,
		FeatMapBookmarkManagerComponent,
		ModalDownloadLayersComponent,
		TestLayerSelectComponent,
		FeatTransactionLogComponent,
		FeatResolutionCenterComponent,
		FeatFlipRoadComponent,
		LineGeomEditWizardComponent,
		LineSplitComponent,
		LineMergeComponent,
		QcLayerSelectModalComponent,
		FeatReferenceDocumentComponent,
		ViewLogComponent,
		UnsavedChangesWarningComponent,
		WizardAddressRelocationComponent,
		WizardCenterlineComponent
	],
	imports: [
		BrowserModule,
		HttpClientModule,
		FormsModule,
		AppRoutingModule,
		JwtModule.forRoot({
			jwtOptionsProvider: {
				provide: JWT_OPTIONS,
				useFactory: jwtOptionsFactory,
				deps: [AuthTokenService]
			}
		}),
		AngularDraggableModule,
		NgxDatatableModule,
		ContextMenuModule.forRoot({
			autoFocus: true
		}),
		BrowserAnimationsModule,
		MatAutocompleteModule,
		MatDialogModule,
		MatProgressBarModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatTabsModule,
		MatButtonToggleModule,
		MatCheckboxModule,
		MatMenuModule,
		MatIconModule,
		MatSelectModule,
		MatTooltipModule,
		DragDropModule,
		ToastrModule.forRoot({
			closeButton: true,
			tapToDismiss: false
		}),
		CookieModule.forRoot(),
		AngularSplitModule,
		// TooltipModule,
		PortalModule,
		OverlayModule
	],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: initFunc,
			multi: true,
			deps: [UserService, BrowserDetectService, SocketSidekickService]
		},
		AppinfoService,
		CancelTranscService,
		ColumnFilterService,
		CommonFunctionService,
		CommonMapService,
		CommonModalService,
		CommonRequestService,
		CommonTableService,
		CommonUtilityService,
		AdminService,
		AdminGuardService,
		AuthService,
		AuthGuardService,
		AuthTokenService,
		UserService,
		AzgivService,
		ArcmapConnectService,
		BrowserDetectService,
		ContentJobsService,
		DownloadService,
		FieldMappingService,
		GfoService,
		GuardConfigIntegratorService,
		IdleService,
		IntegratorService,
		LayerService,
		LayerQcService,
		MiscService,
		PaneControlService,
		RequestTableService,
		ResolverLayersService,
		ResolverJobsTransactionsService,
		ResolverSelectedCustomerService,
		SidekickService,
		SocketService,
		TransactionsService,
		// PopupMessageService,
		EnablePublishLayerService,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: JwtInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpConfigInterceptor,
			multi: true
		},
		SocketSidekickService
		// { provide: LocationStrategy, useClass: HashLocationStrategy }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
